import React, { type ReactNode } from "react";
import "./shell.css";

export function ShellFeatureSurface({ children }: { children: ReactNode }) {
  return <main className="shell-feature-surface">{children}</main>;
}
